import {Component} from '@angular/core';
import {BusinessRuleName, DataFileFormatAcceptability} from '|api/commons';
import {
  DigitalComponentSelectorComponent,
  DOCUMENT_FILE_SUBJECT_LENGTH_LIMIT,
  DocumentTypeSelectorComponent,
  EsslComponentDto,
  EsslComponentsTableColumnSet,
  VisibleClassifiersMode
} from '|shared';
import {FileSettleDocumentDetailDialogData, FileSettleDocumentDetailDialogResult} from '../file-settle-model';
import {
  IczFormContainerDirective,
  IczFormControl,
  IczFormGroup,
  IczValidators,
  TextLength
} from '@icz/angular-form-elements';
import {injectModalData, injectModalRef} from '@icz/angular-modal';
import {ReactiveFormsModule} from '@angular/forms';
import {ButtonComponent, FormButtonsComponent} from '@icz/angular-essentials';
import {IczFormSubmitDirective} from '@icz/angular-application-core';


@Component({
  selector: 'icz-file-settle-document-detail-dialog',
  templateUrl: './file-settle-document-detail-dialog.component.html',
  styleUrls: ['./file-settle-document-detail-dialog.component.scss'],
  imports: [IczFormContainerDirective, ReactiveFormsModule, DocumentTypeSelectorComponent, DigitalComponentSelectorComponent, FormButtonsComponent, ButtonComponent, IczFormSubmitDirective]
})
export class FileSettleDocumentDetailDialogComponent {
  protected modalRef = injectModalRef<Nullable<FileSettleDocumentDetailDialogResult>>();
  protected modalData = injectModalData<FileSettleDocumentDetailDialogData>();

  acceptableDataFileFormats = [DataFileFormatAcceptability.ACCEPTABLE, DataFileFormatAcceptability.RECOMMENDED, DataFileFormatAcceptability.COMPLEMENTARY];

  readonly EsslComponentsTableColumnSet = EsslComponentsTableColumnSet;
  readonly BusinessRuleName = BusinessRuleName;
  readonly VisibleClassifiersMode = VisibleClassifiersMode;

  form = new IczFormGroup({
    documentRefNumber: new IczFormControl<Nullable<string>>(null),
    documentSubject: new IczFormControl<Nullable<string>>(null, [IczValidators.maxLength(DOCUMENT_FILE_SUBJECT_LENGTH_LIMIT)], undefined, TextLength.UNLIMITED),
    documentId: new IczFormControl<Nullable<number>>(null),
    documentTypeId: new IczFormControl<Nullable<number>>(null),
    components: new IczFormControl<Nullable<EsslComponentDto[]>>(null),
    excludedComponentIds: new IczFormControl<Nullable<number[]>>([]),
  });

  get preselectedComponents() {
    return this.form.value.components as EsslComponentDto[];
  }

  confirm() {
    const formValue = this.form.getRawValue();
    this.modalRef.close({
      documentId: formValue.documentId!,
      excludedComponentIds: formValue.excludedComponentIds!,
      documentTypeId: formValue.documentTypeId
    });
  }

  cancel() {
    this.modalRef.close();
  }

  ngOnInit(): void {
    this.form.get('documentId')!.setValue(this.modalData.documentId);
    this.form.get('documentTypeId')!.setValue(this.modalData.documentTypeId);
    this.form.get('components')!.setValue(this.modalData.preselectedComponents);
  }

  setExcludedComponentIds(ids: number[]) {
    this.form.get('excludedComponentIds')!.setValue(ids);
  }
}
